import EA from '../helpers/init';
import LocomotiveScroll from 'locomotive-scroll';

export default EA.Methods.locomotiveScrollInit = () => {
    const sections = document.querySelectorAll('section[data-overlap]');

    sections.forEach((section, index) => {
        const prevSection = section.previousElementSibling;

        if(!prevSection) return;

        prevSection.style.position = 'sticky';
        prevSection.style.top = '0';

        prevSection.setAttribute('data-scroll', '');
        prevSection.setAttribute('data-scroll-css-progress', '');
    });

    const savedScroll = window.scrollY;

    if (savedScroll > 0) {
        // Hide the page, jump to top, let Locomotive init, then jump back
        setTimeout(() => {
            document.documentElement.style.visibility = 'hidden';
            window.scrollTo({ top: 0, behavior: 'instant' });
        }, 0);
    }

    // Init locomotive
    const locomotiveScroll = new LocomotiveScroll({});

    // Restore scroll position
    if (savedScroll > 0) {
        window.addEventListener('load', () => {
            setTimeout(() => {
                window.scrollTo({ top: savedScroll, behavior: 'instant' });
                document.documentElement.style.visibility = 'visible';
            }, 300);    
        });
    }
};